class BlurImage extends HTMLElement {
  connectedCallback() {
    const img = this.querySelector('img:not([data-placeholder])');
    const placeholder = this.querySelector('[data-placeholder]');
    if (!img) return;

    const reveal = (instant) => {
      if (instant) {
        img.classList.remove('transition-opacity');
        placeholder?.classList.remove('transition-opacity');
      }
      img.classList.replace('opacity-0', 'opacity-100');
      placeholder?.classList.add('opacity-0');
    };

    if (img.complete && img.naturalWidth > 0) {
      reveal(true);
    } else {
      img.addEventListener('load', () => reveal(false), { once: true });
      img.addEventListener('error', () => reveal(false), { once: true });
    }
  }
}

customElements.define('blur-image', BlurImage);
